import React, { useEffect, useState } from 'react';

import axios from 'axios';

import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import 'moment/locale/ko';
import Box from '@mui/material/Box';
import { useForm } from 'react-hook-form';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import FormControl from '@mui/material/FormControl';
import { useNavigate } from 'react-router-dom';
import Pagination from '@mui/material/Pagination';
import Container from '@mui/material/Container';

const columns = [
  { id: 'rowNumber', label: 'No', minWidth: 40, align: 'center' },
  { id: 'mail', label: '메일 주소', minWidth: 140, align: 'center' },
  { id: 'codeNm', label: '코드', minWidth: 100, align: 'center' },
  { id: 'createdAt', label: '등록일', minWidth: 180, align: 'center' }
];

const logColumns = [
  { id: 'rowNumber', label: 'No', minWidth: 40, align: 'center' },
  { id: 'recipient', label: '받는사람', minWidth: 140, align: 'center' },
  { id: 'subject', label: '제목', minWidth: 100, align: 'center' },
  { id: 'orderNo', label: '주문번호', minWidth: 40, align: 'center' },
  { id: 'createdAt', label: '등록일', minWidth: 180, align: 'center' }
];

export default function MailMng() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [logRows, setLogRows] = useState([]);
  const [datas, setDatas] = useState({});
  const [codes, setCodes] = useState([]);
  const [pageCnt, setPageCnt] = useState(1);
  const [page, setPage] = useState(1);
  const [offset] = useState(10);

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    reset,
    formState: { errors, isDirty }
  } = useForm({
    mode: 'all'
  });

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const handleChange = (e) => {
    setDatas({ ...datas, [e.target.id]: e.target.value });
  };

  const handleChangeCode = (e) => {
    setDatas({ ...datas, code: e.target.value });
  };

  const handleRowClick = (data) => (evt) => {
    initForm();
    setDatas(data);
    setValue('datas', data);
  };

  const getDataList = async (e) => {
    const response = await axios.get(`/api/mail`);
    if (response.data) {
      const result = response.data;
      setRows(result);
    }
  };

  const getMailLogList = async (e) => {
    let params = {
      offset,
      page,
      limit: offset
    };
    const response = await axios.get(`/api/mail-log`, { params });
    if (response.data) {
      response.data.rows.map((t) => {
        const split = t.recipient.split(',');
        t.recipient = split.length === 1 ? split[0] : `${split[0]} 외 ${split.length - 1}명`;
        return t;
      });
      setPageCnt(Math.ceil(response.data.count / offset));
      setLogRows(response.data.rows);
    }
  };

  const getCodesList = async (e) => {
    await axios
      .get(`/api/code/mail`)
      .then((response) => {
        if (!!response.data) {
          setCodes(response.data);
        }
      })
      .catch((error) => {
        alert(error.response.data.message);
      });
  };

  const onClickInit = (evt) => {
    initForm();
  };

  const initForm = () => {
    setDatas({});
    clearErrors();
    reset();
  };

  const mailMngCreate = async (data) => {
    return await axios.post(`/api/mail`, data);
  };

  const mailMngUpdate = async (data) => {
    return await axios.patch(`/api/mail/${data.id}`, data);
  };

  const onClickDelete = async (evt) => {
    try {
      if (datas.id) {
        await axios
          .delete(`/api/mail/${datas.id}`)
          .then((response) => {
            getDataList();
            initForm();
            alert(response.data.message);
          })
          .catch((error) => {
            alert(error.response.data.message);
          });
      }
    } catch (e) {
      console.log(`insert failed`);
    }
  };

  const createOrUpdate = async (datas) => {
    if (!!datas.id) {
      return await mailMngUpdate(datas);
    } else {
      return await mailMngCreate(datas);
    }
  };

  const onClickMoveEmail = (e) => {
    navigate(`/mail/forward`);
  };

  const handleClickSubject = (row) => (e) => {
    navigate(`/mail/detail`, {
      state: {
        id: row?.id
      }
    });
  };

  const onSubmit = (data) => {
    if (isDirty) {
      createOrUpdate(datas)
        .then((response) => {
          getDataList();
          initForm();
          alert(response.data.message);
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    }
  };

  useEffect(() => {
    getDataList();
    getCodesList();
    getMailLogList();
  }, []);

  useEffect(() => {
    getMailLogList(page);
  }, [page]);

  return (
    <Box>
      <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
        <Typography component="h2" variant="h6" color="primary" gutterBottom>
          메일 관리
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={9}>
            <TableContainer component={'div'} sx={{ maxHeight: 450 }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell key={column.id} align={column.align} sx={{ minWidth: column.minWidth }}>
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row, rowIdx) => (
                    <TableRow hover key={row.id} onClick={handleRowClick(row)}>
                      {columns.map((col, colIdx) => (
                        <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                          {row[col.id]}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={3}>
            <Stack direction="row" spacing={2} justifyContent="flex-end">
              <Button variant="contained" onClick={onClickInit}>
                초기화
              </Button>
              <Button variant="contained" type="submit" form="mailMngForm" disabled={isDirty && JSON.stringify(datas) !== '{}' ? false : true}>
                {!!datas.id ? '수정' : '등록'}
              </Button>
              <Button variant="contained" onClick={onClickDelete} disabled={datas.id ? false : true}>
                삭제
              </Button>
            </Stack>
            <Box id="mailMngForm" component="form" onSubmit={handleSubmit(onSubmit)} noValidate sx={{ mt: 1, minWidth: 300, maxWidth: 500 }}>
              <TextField
                margin="dense"
                required
                fullWidth
                name="mail"
                label="메일주소"
                id="mail"
                value={datas?.mail || ''}
                error={!!errors.mail}
                {...register('mail', {
                  required: '메일을 입력해주세요.',
                  onChange: (e) => handleChange(e)
                })}
              />
            </Box>
            <FormControl fullWidth>
              <InputLabel id="code-label" required>
                코드
              </InputLabel>
              <Select
                labelId="code-label"
                required
                id="code"
                name="code"
                value={datas?.code || ''}
                label="코드"
                error={!!errors.code}
                {...register('code', {
                  required: '코드를 선택해주세요.',
                  onChange: (e) => handleChangeCode(e)
                })}
              >
                {codes.map((item, idx) => {
                  return (
                    <MenuItem key={`code-${idx}`} value={item.cdVal}>
                      <ListItemText primary={item.cdNm} />
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Paper>
      <Paper sx={{ p: 2, mt: 2 }}>
        <Typography component="h2" variant="h6" color="primary" gutterBottom>
          메일 전송 이력
        </Typography>
        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <Button variant="contained" onClick={onClickMoveEmail}>
            메일 보내기
          </Button>
        </Stack>
        <TableContainer component={'div'}>
          <Table size="small">
            <TableHead>
              <TableRow>
                {logColumns.map((column) => (
                  <TableCell key={column.id} align={column.align} sx={{ minWidth: column.minWidth }}>
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {logRows.map((row, rowIdx) => (
                <TableRow hover key={row.id} onClick={handleRowClick(row)}>
                  {logColumns.map((col, colIdx) => (
                    <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                      {col.id === 'subject' ? (
                        <a style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={handleClickSubject(row)}>
                          {row[col.id]}
                        </a>
                      ) : (
                        row[col.id]
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Container maxWidth="sm" sx={{ mt: 2 }}>
          <Pagination count={pageCnt} page={page} onChange={handleChangePage} showFirstButton showLastButton />
        </Container>
      </Paper>
    </Box>
  );
}
